import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {ChevronLeftIcon, ChevronRightIcon} from '@heroicons/react/24/outline';
import styles from './AdminProject.module.css';
import AdminProjectInfo from './AdminProjectInfo';
import {adminProjectListAPI} from "../../../services/admin";
import AdminProjectNote from "./AdminProjectNote";

interface AdminProjectProps {
    projectId: number;
}

//프로젝트 상세 페이지 버튼
const AdminProject: React.FC<AdminProjectProps> = ({projectId}) => {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = React.useState<'info' | 'note'>('info');
    const [projectIds, setProjectIds] = useState<number[]>([]);
    const [currentIndex, setCurrentIndex] = useState<number>(0);

    useEffect(() => {
        const fetchProjects = async () => {
            try {
                //프로젝트 식별자 목록 API
                const response = await adminProjectListAPI();
                setProjectIds(response);
                const index = response.findIndex(pid => pid === projectId);
                setCurrentIndex(index);
            } catch (error) {
                console.error('Error fetching projects:', error);
            }
        };

        fetchProjects();
    }, [projectId]);

    //이전 프로젝트 페이지
    const handlePrevious = () => {
        if (currentIndex > 0) {
            const prevProjectId = projectIds[currentIndex - 1];
            navigate(`/admin/projects/${prevProjectId}`);
        }
    };

    //다음 프로젝트 페이지
    const handleNext = () => {
        if (currentIndex < projectIds.length - 1) {
            const nextProjectId = projectIds[currentIndex + 1];
            navigate(`/admin/projects/${nextProjectId}`);
        }
    };

    //프로젝트 식별자가 없을 경우
    if (!projectId) {
        return <div>Invalid project ID</div>;
    }

    return (
        <div className={styles.container}>
            <div className={styles.navigationContainer}>
                {/*이전 프로젝트 버튼*/}
                <button
                    className={`${styles.navButton} ${currentIndex === 0 ? styles.disabled : ''}`}
                    onClick={handlePrevious}
                    disabled={currentIndex === 0}
                    aria-label="Previous project"
                >
                    <ChevronLeftIcon className={styles.navIcon}/>
                </button>

                <div className={styles.contentWrapper}>
                    <div className={styles.header}>
                        {/*프로젝트 탭 버튼*/}
                        <div className={styles.tab}>
                            {/*프로젝트 정보 버튼*/}
                            <button
                                className={`${styles.tabButton} ${activeTab === 'info' ? styles.active : ''}`}
                                onClick={() => setActiveTab('info')}
                            >
                                Info
                            </button>
                            {/*프로젝트 특이사항 버튼*/}
                            <button
                                className={`${styles.tabButton} ${activeTab === 'note' ? styles.active : ''}`}
                                onClick={() => setActiveTab('note')}
                            >
                                Note
                            </button>
                        </div>
                    </div>

                    {activeTab === 'info' ? (
                        // 프로젝트 정보
                        <AdminProjectInfo projectId={projectId}/>
                    ) : (
                        // 프로젝트 특이사항
                        <AdminProjectNote projectId={projectId}/>
                    )}
                </div>
                {/*다음 프로젝트 버튼*/}
                <button
                    className={`${styles.navButton} ${currentIndex === projectIds.length - 1 ? styles.disabled : ''}`}
                    onClick={handleNext}
                    disabled={currentIndex === projectIds.length - 1}
                    aria-label="Next project"
                >
                    <ChevronRightIcon className={styles.navIcon}/>
                </button>
            </div>
        </div>
    );
};

export default AdminProject;